import * as OpenCC from 'opencc-js'

const cnToHkConverter = OpenCC.Converter({ from: 'cn', to: 'hk' })
const hkToCnConverter = OpenCC.Converter({ from: 'hk', to: 'cn' })

/** 简体中文转繁体中文（香港习惯） */
export const toTraditional = (text: string): string => {
  if (!text) return text
  return cnToHkConverter(text)
}

/** 繁体中文转简体中文 */
export const toSimplified = (text: string): string => {
  if (!text) return text
  return hkToCnConverter(text)
}
